export enum LinkType {
  File = 1,
  URL = 2,
  RouterLink = 3,
}
